// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1303":"1b7925cc","8219":"79340e88"}[chunkId] || chunkId) + "." + {"1303":"48629d576401be9e","2579":"8c4083ffc9dfa829","8219":"f6a044577e4f923c","9497":"bbd8fa1e679c64fe"}[chunkId] + ".js";
};